;(function() {
  'use strict'

  Controller.$inject = ["$q", "$scope", "$state", "$stateParams", "app", "AUTH_EVENTS", "glError", "glAnalytics", "userService", "pageService", "moduleService", "communityService"];
  angular.module('app.crowd').controller('Crowd', Controller)

  /* @ngInject */
  function Controller(
    $q,
    $scope,
    $state,
    $stateParams,
    app,
    AUTH_EVENTS,
    glError,
    glAnalytics,
    userService,
    pageService,
    moduleService,
    communityService
  ) {
    var vm = this

    vm.States = {
      LOADING: 'loading',
      READY: 'ready',
      FORM_HIDDEN: 'form-hidden',
    }

    vm.Pathways = {
      LOGGED_IN: 'logged-in',
      HAVE_EMAIL: 'have-email',
      UNKNOWN: 'unknown',
    }

    vm.pageId = $stateParams.pageId
    vm.redirect = parseRedirectUrl($stateParams.redirect)
    vm.userEmail = $stateParams.userEmail

    vm.formData = {}

    vm.usernameChecker = userService.getUsernameChecker()
    vm.emailChecker = userService.getEmailChecker()

    vm.promptLogin = promptLogin
    vm.canJoin = canJoin
    vm.performRedirect = performRedirect
    vm.submit = submit

    $scope.$on(AUTH_EVENTS.loginSuccess, onLogin)

    activate()

    function activate() {
      // Pathways:
      // - logged in
      //   - check if they have joined
      //   - if not, show button to join
      //   - redirect to page
      // - have an email
      //   - get roles
      //   - if email user
      //     - show username/password fields
      //     - button = signup + join crowd
      //     - redirect to page
      //   - if full user
      //     - display join button
      //     - button prompts login
      //     - ensure they are joined
      //     - redirect to page
      // - unknown
      //   - show full form (email/username/password)
      //   - check email for roles (if full user prompt to login)
      //   - sign them up + join crowd
      //   - redirect to page

      getPathway().then(function(pathway) {
        vm.pathway = pathway

        if (pathway === vm.Pathways.LOGGED_IN) {
          communityService.getAll().promise.then(function() {
            var isJoined = communityService.get(vm.elementId).isJoined()

            if (isJoined) {
              track('AlreadyJoined', vm.elementId)
              performRedirect()
              return
            }

            track('Prompted', vm.elementId)
            vm.state = vm.States.READY
          }, glError.fromStatus)
        }

        if (pathway === vm.Pathways.HAVE_EMAIL) {
          userService.getRolesByEmail(vm.userEmail).then(
            function(roles) {
              var hasEmailRole = _.includes(roles, userService.Roles.EMAIL)
              var hasPhoneRole = _.includes(roles, userService.Roles.PHONE)

              if (hasEmailRole) {
                track('Prompted', vm.elementId)
                vm.formData.email = vm.userEmail
                vm.emailChecker.check(vm.userEmail) // fire it off
                vm.showForm = true
                vm.state = vm.States.READY
                return
              }

              if (hasPhoneRole) {
                promptLogin(true)
                return
              }
            },
            function() {
              // no user found with email
              track('Prompted', vm.elementId)
              vm.formData.email = vm.userEmail
              vm.emailChecker.check(vm.userEmail) // fire it off
              vm.showForm = true
              vm.state = vm.States.READY
            }
          )
        }

        if (pathway === vm.Pathways.UNKNOWN) {
          track('Prompted', vm.elementId)
          vm.showForm = true
          vm.state = vm.States.READY
          return
        }
      })
    }

    function getPathway() {
      return $q(function(resolve) {
        // get page
        pageService.get(vm.pageId).then(function(page) {
          vm.page = page
          app.setTitle(page.title)

          // get crowd elementId
          getCrowdElementId(page.id).then(function(elementId) {
            vm.elementId = elementId

            track('Landed', elementId)

            // resolve with pathway

            if (
              userService.loggedIn() &&
              vm.userEmail &&
              vm.userEmail !== userService.get().email
            ) {
              userService.logout()
            }

            if (userService.loggedIn()) {
              return resolve(vm.Pathways.LOGGED_IN)
            }

            if (vm.userEmail) {
              return resolve(vm.Pathways.HAVE_EMAIL)
            }

            return resolve(vm.Pathways.UNKNOWN)
          }, performRedirect)
        }, glError.fromStatus)
      })
    }

    function getCrowdElementId(pageId) {
      return $q(function(resolve, reject) {
        moduleService.getByPage(pageId).then(function(modules) {
          if (
            !modules.community ||
            !modules.community.data ||
            !modules.community.data.elementId
          ) {
            track('NoCrowd', pageId)
            return reject()
          }
          return resolve(modules.community.data.elementId)
        })
      })
    }

    function parseRedirectUrl(url) {
      if (!url) {
        return
      }
      if (!url.match(/^[a-zA-Z]+:\/\//)) {
        url = 'http://' + url
      }
      return url
    }

    function performRedirect() {
      if (!vm.redirect) {
        return $state.go('app.page', { id: vm.pageId }, { location: 'replace' })
      }
      window.location.href = vm.redirect
    }

    function promptLogin(onFailRedirect) {
      vm.state = vm.States.FORM_HIDDEN
      var msg = vm.userEmail
        ? 'Please sign in with your ' + vm.userEmail + ' account.'
        : 'Please sign in...'
      userService.promptLogin(msg).then(angular.noop, function() {
        if (onFailRedirect) {
          return performRedirect()
        }
        $state.reload()
      })
    }

    function onLogin() {
      $state.reload()
    }

    function canJoin() {
      var form = vm.form

      var validUsername =
        form.$valid && vm.usernameChecker.state === 'available'
      var validEmail = form.$valid && vm.emailChecker.state === 'available'
      var validPassword = form.$valid

      var validForm = validUsername && validEmail && validPassword

      return vm.showForm ? validForm : true
    }

    function submit() {
      vm.isJoining = true

      if (vm.pathway === vm.Pathways.LOGGED_IN) {
        communityService
          .get(vm.elementId)
          .join()
          .then(function() {
            track('Joined', vm.elementId)
            performRedirect()
          }, glError.internal)
        return
      }

      userService.signup(vm.formData).then(function() {
        communityService
          .get(vm.elementId)
          .join()
          .then(function() {
            track('Joined', vm.elementId)
            performRedirect()
          }, glError.internal)
      }, glError.fromStatus)
    }

    function track(action, label) {
      glAnalytics.track('Crowd', action, label)
    }
  }
})()
